import React from "react";
import images from "../../../Utils/importImages";

function PassportDetails({ generalDetail , setEditPassportProfile}) {
  let getDateFormatted = (date) => {
    if (!date) return ""; // Handle cases where date is undefined or null

    let [year, month, day] = date.split("-"); // Assuming format is "DD-MM-YYYY"

    // Convert month number to month name
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let monthName = monthNames[parseInt(month, 10) - 1]; // Convert month to index

    return `${day} / ${monthName} / ${year}`;
  };

  const isPassportExpired = (ppvalue) => {
    if (!ppvalue) return false; // If null, assume it's not expired (or handle as needed)

    const expiryDate = new Date(ppvalue);
    const today = new Date();

    // Ensure the provided date is valid
    if (isNaN(expiryDate.getTime())) {
      console.warn("Invalid date format:", ppvalue);
      return false;
    }

    return expiryDate < today; // Returns true if expired, false otherwise
  };

  return (
    <div className="userdb-content-right-internal-top">
      <div className="internal-tab-head">
        <h3>Passport Details</h3>
        <div className="editable-profile-action">
          Edit <img src={images["edit-profile-details.svg"]} alt="" onClick={() => setEditPassportProfile(true)}/>
        </div>
      </div>
      <ul className="myprofile-general-details">
        <li>
          <label for="">Passport No.</label>
          <div className="myprofile-general-value country">
            {generalDetail?.passport_number == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.passport_number
            )}
          </div>
        </li>

        <li
          className={
            isPassportExpired(generalDetail?.passport_expiry_date)
              ? "list-maintainer"
              : ""
          }
        >
          <label for="">Passport Expiry Date</label>
          <div className="myprofile-general-value">
            {generalDetail?.passport_expiry_date == null ? (
              <span>Not Provided</span>
            ) : isPassportExpired(generalDetail?.passport_expiry_date) ? (
              <div className="status-wrapper">
                {getDateFormatted(generalDetail?.passport_expiry_date)}
                <div className="expired proxima_semibold color_crimson">
                  Expired
                </div>
              </div>
            ) : (
              getDateFormatted(generalDetail?.passport_expiry_date)
            )}
          </div>
        </li>
        <li>
          <label for="">Passport Issue Date</label>
          <div className="myprofile-general-value">
            {generalDetail?.passport_issue_date == null ? (
              <span>Not Provided</span>
            ) : (
              getDateFormatted(generalDetail?.passport_issue_date)
            )}
          </div>
        </li>
        <li>
          <label for="">Issuing Country</label>
          <div className="myprofile-general-value country">
            {generalDetail?.passport_issuing_country_id == null ? (
              <span>Not Provided</span>
            ) : (
              generalDetail?.passport_issuing_country.name
            )}
          </div>
        </li>
      </ul>
    </div>
  );
}

export default PassportDetails;
